import React from 'react';
import PropTypes from 'prop-types';

import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

export default class FilterInput extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.any,
      value: PropTypes.any,
      label: PropTypes.any
    }))
  };

  render() {
    return (
      <FormGroup>
        <ControlLabel>{this.props.label}</ControlLabel>
        {this.renderInput()}
      </FormGroup>
    );
  }

  renderInput() {
    const { label, placeholder, ...otherProps } = this.props;
    return <FormControl placeholder={placeholder || label} {...otherProps} />;
  }
}
